import { ENABLE_CROSS_CHAIN_NETWORK_IDS } from '@/constants/ENABLE_CROSS_CHAIN_NETWORK_IDS';
import { DEFAULT_NETWORK_ID } from './networkParams.helper';

export const ENABLE_CROSS_CHAIN = ENABLE_CROSS_CHAIN_NETWORK_IDS.includes(DEFAULT_NETWORK_ID ?? '');
console.log('ENABLE_CROSS_CHAIN : ', ENABLE_CROSS_CHAIN);
